import React, { useEffect, useState } from "react";
import Loader from "../layout/Loader";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import MetaData from "../layout/MetaData";
import AdminLayout from "../layout/AdminLayout";
import { useDeleteUserMutation, useGetAdminUsersQuery } from "../../redux/api/userApi";

const ListUsers = () => {
    const { data, isLoading, error } = useGetAdminUsersQuery();

    const [deleteUser, { error: deleteError, isLoading: isDeleteLoading, isSuccess }] = useDeleteUserMutation()


    useEffect(() => {
        if (error) {
            toast.error(error?.data?.message);
        }
        if (deleteError) {
            toast.error(deleteError?.data?.message);
        }
        if (isSuccess) {
            toast.success("User Deleted")
        }
    }, [error, deleteError, isSuccess]);

    const deleteUserHandler = (id) => {
        deleteUser(id)
    }

    // Users array
    const users = data?.users || [];

    // Pagination state
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const totalPages = Math.max(1, Math.ceil(users.length / perPage));
    const startIdx = (page - 1) * perPage;
    const endIdx = Math.min(users.length, startIdx + perPage);
    const currentUsers = users.slice(startIdx, endIdx);

    if (isLoading) return <Loader />;

    return (
        <AdminLayout>
            <MetaData title="All Users" />
            <div
                className="container-fluid py-4 pt-0 mt-0"
                style={{fontFamily: "Quicksand, sans-serif" }}
            >


                <div className="card shadow-sm rounded-4 border-0 p-4">
                    <div className="d-flex flex-wrap justify-content-between align-items-center mb-3 gap-2">
                        <h2 className="fw-bold m-0" style={{ color: "#e04f6e" }}>{users.length} Users</h2>
                        <div className="d-flex align-items-center gap-2">
                            <span className="small" style={{ color: "#e04f6e" }}>Rows per page</span>
                            <select
                                className="form-select form-select-sm"
                                style={{ width: 90 }}
                                value={perPage}
                                onChange={(e) => { setPerPage(Number(e.target.value)); setPage(1); }}
                            >
                                <option value={5}>5</option>
                                <option value={10}>10</option>
                                <option value={20}>20</option>
                                <option value={50}>50</option>
                            </select>
                        </div>
                    </div>

                    <div className="d-flex flex-column gap-3">
                        {currentUsers.map((user) => (
                            <div key={user?._id} className="rounded-4 p-3 bg-white shadow-sm">
                                <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-2">
                                    <h5 className="fw-bold m-0 text-break" style={{ color: "#e04f6e" }}>{user?._id}</h5>
                                    <div className="d-flex align-items-center gap-2 flex-shrink-0">
                                        <Link
                                            to={`/admin/users/${user?._id}`}
                                            className="btn btn-outline-primary btn-sm"
                                        >
                                            <i className="fa fa-pencil"></i>
                                        </Link>
                                        <button
                                            className="btn btn-outline-danger btn-sm ms-2"
                                            onClick={() => deleteUserHandler(user?._id)}
                                            disabled={isDeleteLoading}
                                        >
                                            <i className="fa fa-trash"></i>
                                        </button>
                                    </div>
                                </div>

                                <div className="d-flex flex-wrap gap-4">
                                    <div>
                                        <div className="small fw-semibold" style={{ color: '#e04f6e' }}>Name</div>
                                        <div className="text-break" style={{ color: "#e04f6e" }}>{user?.name}</div>
                                    </div>
                                    <div>
                                        <div className="small fw-semibold" style={{ color: '#e04f6e' }}>Email</div>
                                        <div className="text-break" style={{ color: "#e04f6e" }}>{user?.email}</div>
                                    </div>
                                    <div>
                                        <div className="small fw-semibold" style={{ color: '#e04f6e' }}>Role</div>
                                        <div className="text-break" style={{ color: "#e04f6e" }}>{user?.role}</div>
                                    </div>
                                </div>
                            </div>
                        ))}
                        {users.length === 0 && (
                            <div className="text-center text-muted">No users found.</div>
                        )}
                    </div>

                    {/* Pagination controls */}
                    {users.length > 0 && (
                        <div className="d-flex flex-wrap justify-content-between align-items-center mt-3 gap-2">
                            <div className="small text-muted">Showing {users.length === 0 ? 0 : startIdx + 1}–{endIdx} of {users.length}</div>
                            <div className="d-flex align-items-center gap-2">
                                <button
                                    className="btn btn-sm btn-outline-secondary"
                                    disabled={page <= 1}
                                    onClick={() => setPage((p) => Math.max(1, p - 1))}
                                >
                                    Prev
                                </button>
                                <span className="small">Page {page} of {totalPages}</span>
                                <button
                                    className="btn btn-sm btn-outline-secondary"
                                    disabled={page >= totalPages}
                                    onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                                >
                                    Next
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>

        </AdminLayout>

    );
};

export default ListUsers;
